@for (group of formattedSchedule; track group.dayLabelKeys[0]) {
  <div class="flex justify-between mb-2 last:mb-0">
    <span nz-typography nzType="secondary">
      {{ group.dayLabelKeys[0] | translate }}
      @if (group.dayLabelKeys[1]) {
        - {{ group.dayLabelKeys[1] | translate }}
      }
    </span>
    <span>
      @if (group.intervals.length) {
        @for (interval of group.intervals; track interval) {
          {{ interval }}
        }
      } @else {
        {{ 'shared.schedule.closed' | translate }}
      }
    </span>
  </div>
}
@if (location?.address) {
  <nz-divider></nz-divider>

  <div class="flex justify-between gap-2">
    <span nz-typography nzType="secondary" class="text-nowrap">{{ 'shared.labels.address' | translate }}:</span>
    <div class="flex flex-col ant-flex-align-flex-end">
      <span>{{ location?.address }}</span>
      <div>
        <span>{{ location?.city }}</span>
        @if (location?.stateCode) {
          <span>, {{ location?.stateCode }}</span>
        }
      </div>
    </div>
  </div>
}
